import './docs.css';
import { getDocs } from './docsStatic' with { type: 'macro' };

const docs = await getDocs();

export function Docs({
  path,
  goTo,
}: {
  path: string;
  goTo: (path: string) => void;
}) {
  const content = docs[path] || '<h1>404 - Document Not Found</h1>';

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;

    // Check if the clicked element is an anchor tag or within one
    const anchor = target.closest('a');
    if (anchor && anchor.href) {
      // Only intercept relative URLs (internal links)
      const url = new URL(anchor.href, window.location.origin);
      if (url.origin === window.location.origin) {
        e.preventDefault();
        console.log('Navigating to doc path:', url.pathname);
        goTo(url.pathname);
      }
    }
  };

  return (
    <div
      className="docs-content"
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
